const ua = typeof window === 'undefined' ? 'node.js' : window.navigator.userAgent;
let version;
export const browser = {};
const ios = /ip(hone|od|ad)/i.test(ua);
const android = /android/i.test(ua);
const blackberry = /blackberry/i.test(ua);
const webos = /webos/i.test(ua);
const kindle = /silk|kindle/i.test(ua);
const ie = /MSIE|Trident|Edge/i.test(ua);
if (ie) {
    browser.ie = true;
    if (/MSIE/i.test(ua)) {
        version = /MSIE\s+(\d+\.\d+)/i.exec(ua);
    }
    else {
        version = /Trident.*rv[ :](\d+\.\d+)/.exec(ua);
    }
    browser.version = version && parseFloat(version[1]);
    browser.ielt9 = browser.version < 9;
    browser.ielt10 = browser.version < 10;
    browser.ielt11 = browser.version < 11;
}
if (typeof window !== 'undefined' && ios) {
    browser.ios = true;
    version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    browser.version = version && parseFloat(version[1] + '.' + version[2]);
}
browser.mobile = /mobile/i.test(ua) || ios || android || blackberry || webos || kindle;
browser.firefox = /firefox/i.test(ua);
if (/safari/i.test(ua)) {
    browser.chrome = /chrome/i.test(ua);
    browser.safari = !browser.chrome;
}
if (typeof window === 'undefined' && browser.safari) {
    version = navigator.appVersion.match(/Version\/(\d+(\.\d+)?)/);
    browser.version = version && parseFloat(version[1]);
}
browser.phone = browser.mobile && isInResponsiveMobileMode();
browser.touch = isTouch();
function isInResponsiveMobileMode() {
    return ((typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 520px)').matches) ||
        (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 736px) and (orientation:landscape)').matches));
}
function isTouch() {
    if ('ontouchstart' in window) {
        return true;
    }
    return false;
}
//# sourceMappingURL=BrowserHelper.js.map